import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { FilterGroup, FilterOption } from 'apps/find-designers/propTypes';
import CheckableFilterOption from './CheckableFilterOption';

class CheckboxFilter extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    getToggledValue(value, checked, options) {
        if (checked) {
            return options.concat(value);
        }

        return options.filter(option => option !== value);
    }

    handleChange(e) {
        const { name, value, checked } = e.target;

        this.props.onChange(
            name,
            this.getToggledValue(value, checked, [...this.props.filter.value])
        );
    }

    render() {
        return (
            <div>
                {this.props.options.map(option => (
                    <CheckableFilterOption
                        filterOption={option}
                        isChecked={this.props.filter.value.includes(option.value)}
                        key={option.id}
                        type={'checkbox'}
                        onChange={this.handleChange}
                    />
                ))}
            </div>
        );
    }
}

CheckboxFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: FilterGroup.isRequired,
    options: PropTypes.oneOfType([MobxPropTypes.observableArray, PropTypes.arrayOf(FilterOption)])
        .isRequired,
};

export default observer(CheckboxFilter);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/CheckboxFilter.jsx